import { render, staticRenderFns } from "./MyService.vue?vue&type=template&id=182f047a&"
import script from "./MyService.vue?vue&type=script&lang=ts&"
export * from "./MyService.vue?vue&type=script&lang=ts&"
import style0 from "./MyService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports